import { render, staticRenderFns } from "./Tipouso.vue?vue&type=template&id=2de6b32c&"
import script from "./Tipouso.vue?vue&type=script&lang=js&"
export * from "./Tipouso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports